var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "constructor" },
    [
      _c(
        "c-sidesheet",
        {
          attrs: { title: "Конструктор фильтров", active: _vm.localActive },
          on: { close: _vm.close },
        },
        [
          _c("div", { staticClass: "constructor__wrapper" }, [
            _c("div", { staticClass: "constructor__description" }, [
              _vm._v(
                " Перетаскивайте вправо названия полей, чтобы настроить их видимость в основном фильтре раздела. Поля в фильтре будут располагаться в том же порядке, что и в правом столбце конструктора. "
              ),
            ]),
            _c("div", { staticClass: "constructor__content" }, [
              _c(
                "div",
                { staticClass: "constructor__search" },
                [
                  _c("c-input-old", {
                    attrs: {
                      icon: "search",
                      "placeholder-style": "italic",
                      placeholder: "Поиск",
                      clearable: true,
                    },
                    model: {
                      value: _vm.searchInput,
                      callback: function ($$v) {
                        _vm.searchInput = $$v
                      },
                      expression: "searchInput",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "constructor__sections" }, [
                _c(
                  "div",
                  { staticClass: "constructor__section" },
                  [
                    _c("div", { staticClass: "constructor__section-title" }, [
                      _vm._v("Скрытые поля"),
                    ]),
                    _c(
                      "draggable",
                      {
                        staticClass: "constructor__section-content",
                        attrs: {
                          "force-fallback": true,
                          "ghost-class": "sortable__ghost",
                          group: "allFilters",
                        },
                        model: {
                          value: _vm.disabled,
                          callback: function ($$v) {
                            _vm.disabled = $$v
                          },
                          expression: "disabled",
                        },
                      },
                      _vm._l(_vm.disabled, function (field) {
                        return _c(
                          "div",
                          {
                            key: field.name,
                            staticClass: "constructor__element",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "constructor__element-label" },
                              [
                                _c("p", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        field.label ? field.label : field.name
                                      )
                                    ),
                                  ]),
                                  _vm._v(" " + _vm._s(field.description) + " "),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "constructor__element-icon" },
                              [
                                _c("c-icon", {
                                  attrs: { icon: "positioning" },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "constructor__section" },
                  [
                    _c("div", { staticClass: "constructor__section-title" }, [
                      _vm._v("Отображающиеся поля"),
                    ]),
                    _c(
                      "draggable",
                      {
                        staticClass: "constructor__section-content",
                        attrs: {
                          "force-fallback": true,
                          "ghost-class": "sortable__ghost",
                          group: "allFilters",
                        },
                        model: {
                          value: _vm.enabled,
                          callback: function ($$v) {
                            _vm.enabled = $$v
                          },
                          expression: "enabled",
                        },
                      },
                      _vm._l(_vm.enabled, function (field) {
                        return _c(
                          "div",
                          {
                            key: field.name,
                            staticClass: "constructor__element",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "constructor__element-label" },
                              [
                                _c("p", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        field.label ? field.label : field.name
                                      )
                                    ),
                                  ]),
                                  _vm._v(" " + _vm._s(field.description) + " "),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "constructor__element-icon" },
                              [
                                _c("c-icon", {
                                  attrs: { icon: "positioning" },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "constructor__actions" }, [
                _c(
                  "div",
                  { staticClass: "constructor__actions-item" },
                  [
                    _c("c-button", {
                      attrs: { label: "Отменить" },
                      on: { click: _vm.reset },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "constructor__actions-item" },
                  [
                    _c("c-button", {
                      attrs: { label: "Сохранить", color: "primary" },
                      on: { click: _vm.save },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }